var map = {
	"./additionalInfoIcon.svg": 612,
	"./arrowLeftIcon.svg": 613,
	"./arrowMediumTop.svg": 614,
	"./arrowRightIcon.svg": 615,
	"./arrowRightIconSharp.svg": 616,
	"./arrowRightSmallIcon.svg": 617,
	"./arrowScalableIcon.svg": 618,
	"./arrowSelect2.svg": 619,
	"./arrowSelectIcon.svg": 620,
	"./benefit1.svg": 621,
	"./benefit2.svg": 622,
	"./benefit3.svg": 623,
	"./cardsIcon.svg": 624,
	"./circleInfoIcon.svg": 625,
	"./copyIcon copy.svg": 626,
	"./copyIcon.svg": 627,
	"./crossIcon.svg": 628,
	"./crossIcon2.svg": 629,
	"./crossIcon3.svg": 630,
	"./crossIconSmall.svg": 631,
	"./crossSmallIcon.svg": 632,
	"./defaultCategoryIcon.svg": 633,
	"./depNumberIcon.svg": 634,
	"./elfCentralIcon.svg": 635,
	"./equalitySign.svg": 636,
	"./errorIcon.svg": 637,
	"./eyeClosedIcon.svg": 638,
	"./eyeOpenIcon.svg": 639,
	"./favoritesIcon.svg": 640,
	"./favoritesLabelIcon.svg": 641,
	"./filterDivider.svg": 642,
	"./filterIcon.svg": 643,
	"./frequencyIcon.svg": 644,
	"./fsAmountIcon.svg": 645,
	"./fullScreenIcon.svg": 646,
	"./gameIcon.svg": 647,
	"./goldGiftIcon.svg": 648,
	"./hamburgerIcon.svg": 649,
	"./infoIcon.svg": 650,
	"./infoSymbol.svg": 651,
	"./levelBackground.svg": 652,
	"./levelBackgroundNew.svg": 653,
	"./linkIcon.svg": 654,
	"./lockIcon.svg": 655,
	"./lockSharpIcon.svg": 656,
	"./maxBonusAmountIcon.svg": 657,
	"./maxWinFsIcon.svg": 658,
	"./menu/fortuneIcon.svg": 394,
	"./menu/fortuneIconL.svg": 395,
	"./menu/helpdeskIcon.svg": 396,
	"./menu/helpdeskIconL.svg": 397,
	"./menu/homeIcon.svg": 398,
	"./menu/homeIconLarge.svg": 399,
	"./menu/jackpotIcon.svg": 400,
	"./menu/logo.svg": 401,
	"./menu/logoSmall.svg": 402,
	"./menu/loyaltyIcon.svg": 403,
	"./menu/mobileAppIcon.svg": 404,
	"./menu/profileIcon.svg": 405,
	"./menu/questIcon.svg": 406,
	"./menu/questsIcon.svg": 407,
	"./menu/rewardLineupIcon.svg": 408,
	"./menu/searchIcon.svg": 409,
	"./menu/searchIconLarge.svg": 410,
	"./menu/signOutIcon.svg": 411,
	"./menu/star.svg": 412,
	"./menu/tournamentIcon.svg": 413,
	"./menu/tournamentLargeIcon.svg": 414,
	"./menu/vipIcon.svg": 415,
	"./menu/wheelIcon.svg": 416,
	"./menu/wheelIconL.svg": 417,
	"./menu/wheelIconMobile.svg": 418,
	"./menuIcon.svg": 659,
	"./minDepIcon.svg": 660,
	"./noTournamentIcon.svg": 661,
	"./numbers/number-1.svg": 419,
	"./numbers/number-2.svg": 420,
	"./numbers/number-3.svg": 421,
	"./numbers/number-4.svg": 422,
	"./numbers/number-5.svg": 423,
	"./numbers/number-6.svg": 424,
	"./numbers/number-7.svg": 425,
	"./numbers/number-8.svg": 426,
	"./numbers/number-9.svg": 427,
	"./numbers/number-shine-1.svg": 428,
	"./numbers/number-shine-2.svg": 429,
	"./numbers/number-shine-3.svg": 430,
	"./numbers/number-shine-4.svg": 431,
	"./numbers/number-shine-5.svg": 432,
	"./numbers/number-shine-6.svg": 433,
	"./numbers/number-shine-7.svg": 434,
	"./numbers/number-shine-8.svg": 435,
	"./numbers/number-shine-9.svg": 436,
	"./playIcon.svg": 662,
	"./polygon.svg": 663,
	"./preloaderDotsAnimation.svg": 664,
	"./preloaderSpinnerAnimation.svg": 665,
	"./present2Icon.svg": 666,
	"./presentIcon.svg": 667,
	"./promoIcon.svg": 668,
	"./recentIcon.svg": 669,
	"./search2Icon.svg": 670,
	"./search3Icon.svg": 671,
	"./sharpTickIcon copy.svg": 672,
	"./sharpTickIcon.svg": 673,
	"./smallInfoSymbol.svg": 674,
	"./smoothArrowIcon.svg": 675,
	"./successIcon.svg": 676,
	"./supportIcon.svg": 677,
	"./tag1Icon.svg": 678,
	"./tag2Icon.svg": 679,
	"./tag3Icon.svg": 680,
	"./tag4Icon.svg": 681,
	"./tickIcon.svg": 682,
	"./unverified.svg": 683,
	"./verified.svg": 684,
	"./wagerIcon.svg": 685,
	"./wagerTimeIcon.svg": 686,
	"./warningIcon.svg": 687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 611;